import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';
import { RocketChatUser } from './types';

export const createUser = async (user: RocketChatUser): Promise<AxiosResponse> =>
  AxiosInstance.post('users.create', user);
